import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalCommonInsuranceDataReceivedAction,
  GlobalVereinbarungenChangedAction,
  GlobalVertragslaufzeitChangedAction,
  GlobalVorbelegungForBeibehaltungRequestedAction,
  GlobalVorversicherungVorhandenChangedAction,
  TARIF_CHECKED,
  VorbelegungPayload,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  UnfallVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { IAppState } from '../appState';

export const unfVertragsoptionenReducer = function (
  sectionState: IAppState['vertragsoptionen'] = null,
  action: AnyAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  sectionState = vertragsoptionenReducer(sectionState, action, App.UNF, state);
  switch (action.type) {
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED:
      return initVertragsoptionenWithShopData(
        sectionState,
        action as GlobalCommonInsuranceDataReceivedAction,
      );
    case GlobalActions.VERTRAGSLAUFZEIT_CHANGED:
      return changeVertragslaufzeit(
        sectionState,
        action as GlobalVertragslaufzeitChangedAction,
        state,
      );
    case GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED:
      return getVorversicherungVorhanden(
        sectionState,
        action as GlobalVorversicherungVorhandenChangedAction,
        state,
      );
    case TARIF_CHECKED:
      return checkTarif(sectionState, state, action);
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE:
      return addVorvertragToAngeboteReducer(sectionState, action, App.UNF, state.angebotsId);
    case GlobalActions.VEREINBARUNGEN_CHANGED:
      return getVereinbarungen(sectionState, action as GlobalVereinbarungenChangedAction, state);
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED:
      return initVertragsoptionenFromVorvertragData(
        sectionState,
        action as GlobalVorbelegungForBeibehaltungRequestedAction,
        state,
      );
    case GlobalActions.VORBELEGUNG_FINISHED: {
      const actionPayload: VorbelegungPayload = action.payload;
      const { appId, angebotsId } = actionPayload;
      if (appId === App.UNF && angebotsId === state.angebotsId) {
        const unfallVorbelegungdaten: UnfallVorbelegungdaten =
          actionPayload.vorhandeneVorbelegungdaten as UnfallVorbelegungdaten;
        return {
          ...sectionState,
          urbeginn: unfallVorbelegungdaten.urbeginn,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};

function getVereinbarungen(
  sectionState: IAppState['vertragsoptionen'],
  action: GlobalVereinbarungenChangedAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  const matchingUpdate = action.payload.kuendingungChanged.some(
    elem => elem.appId === App.UNF && state.angebotsId === elem.angebotsId,
  );
  return matchingUpdate ? { ...sectionState, vorvertragGekuendigt: true } : { ...sectionState };
}

function checkTarif(
  sectionState: IAppState['vertragsoptionen'],
  state: IAppState,
  action: AnyAction,
): IAppState['vertragsoptionen'] {
  determineLaufzeit(action, sectionState, state.produkt, sectionState);
  return { ...sectionState };
}

function initVertragsoptionenWithShopData(
  sectionState: IAppState['vertragsoptionen'],
  action: GlobalCommonInsuranceDataReceivedAction,
): IAppState['vertragsoptionen'] {
  const { zahlungsweise, zahlungsart, angebotsdatum } = action.payload.vertragsoptionen;
  return {
    ...sectionState,
    zahlungsweise,
    zahlungsart,
    angebotsdatum: sectionState.angebotsdatum ? sectionState.angebotsdatum : angebotsdatum,
  };
}

function getVorversicherungVorhanden(
  sectionState: IAppState['vertragsoptionen'],
  action: GlobalVorversicherungVorhandenChangedAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  const { vorhanden, appId, angebotsId } = action.payload;
  return appId === App.UNF && state.angebotsId === angebotsId
    ? {
        ...sectionState,
        vorversicherungVorhanden: vorhanden,
      }
    : { ...sectionState };
}

function changeVertragslaufzeit(
  sectionState: IAppState['vertragsoptionen'],
  action: GlobalVertragslaufzeitChangedAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  const { appId, angebotsId, vertragslaufzeit } = action.payload;
  if (appId === App.UNF && angebotsId === state.angebotsId) {
    return {
      ...sectionState,
      vertragslaufzeit,
      ausgewaehltevertragslaufzeit: vertragslaufzeit,
    };
  }
  return sectionState;
}

function initVertragsoptionenFromVorvertragData(
  sectionState: Vertragsoptionen,
  action: GlobalVorbelegungForBeibehaltungRequestedAction,
  state: IAppState,
): IAppState['vertragsoptionen'] {
  if (action.payload.forApp === App.UNF && action.payload.angebotsId === state.angebotsId) {
    return { ...getVetragsOptionenFromVorvertrag(sectionState, action.payload) };
  }
  return sectionState;
}
